module.exports = __webpack_public_path__ + "static/scale-model-of-wichita-falls-texas-6de3bfba87fdd70927358c7fa6535104.png";